import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class InvalidReportCalDateError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, additionalData) {
    super(reportService, 'Invalid date in Reporting Calendar - Dates must be in a valid ISO format', 'INVALID_DATE', 0, true, additionalData);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/InvalidReportCalDateError.ts